import { constructAsync } from '../../../../webmodule-common/other/async-constructor';
import { FranchiseeQuoteCreateProjectModal } from './franchisee-quote-create-project-modal';
import { UiQuoteUserInteraction } from '../../../quotes/views/quote-user-interaction-ui';

import type {
  FranchiseeProjectSetupRequest,
  FranchiseeProjectSetupResponse,
  FranchiseeQuoteUserInteraction
} from '../data/franchisee-quote-user-interaction';

/**
 * Lit-backed {@link FranchiseeQuoteUserInteraction}: the shared quote interactions, plus the
 * project-setup modal the franchisee manager used to construct inline.
 */
export class UiFranchiseeQuoteUserInteraction extends UiQuoteUserInteraction implements FranchiseeQuoteUserInteraction {
  async setupProject(request: FranchiseeProjectSetupRequest): Promise<FranchiseeProjectSetupResponse | null> {
    const modal = await constructAsync(
      new FranchiseeQuoteCreateProjectModal({
        clientId: request.clientId,
        title: request.title,
        description: request.description,
        defaultAddress: request.defaultAddress,
        shippingNotes: request.shippingNotes,
        budget: request.budget
      })
    );
    await modal.showModal();
    if (!modal.ok) return null;

    return {
      needsProjectCreate: modal.needsProjectCreate,
      projectTitle: modal.projectTitle,
      description: modal.description,
      projectAddress: modal.projectAddress,
      shippingNotes: modal.shippingNotes,
      budget: modal.budget,
      project: modal.project
    };
  }
}
